import Guid from "common/values/guid/guid";
import Name from "common/values/name/name";
import EntityClientRepresentative, { EntityClientRepresentativeJSON } from "work/entities/entity-client-representative/entity-client-representative";

export interface ClientTeamJSON {
  leader: EntityClientRepresentativeJSON
  members: string[];
}

export default class ClientTeam {
  leader: EntityClientRepresentative;
  members: Guid[] = [];

  constructor(client: EntityClientRepresentative, members: Guid[] = []) {
    this.leader = client;
    this.members = members;
  }

  public addMember(member: Guid): void {
    if (!this.members.includes(member)) {
      this.members.push(member);
    }
  }

  public removeMember(member: Guid): void {
    const index = this.members.indexOf(member);
    if (index !== -1) {
      this.members.splice(index, 1);
    }
  }

  public clone(): ClientTeam {
    return new ClientTeam(
      new EntityClientRepresentative(
        this.leader.userId,
        this.leader.entityId,
        this.leader.name
      ),
      [...this.members]);
  }

  public isEqualTo(other: ClientTeam): boolean {
    if (this.leader.userId !== other.leader.userId ||
      this.leader.entityId !== other.leader.entityId) {
      return false;
    }
    if (this.members.length !== other.members.length) {
      return false;
    }
    for (let i = 0; i < this.members.length; i++) {
      if (this.members[i] !== other.members[i]) {
        return false;
      }
    }
    return true;
  }

  public toJSON(): ClientTeamJSON {
    return {
      leader: this.leader.toJSON(),
      members: this.members.map(member => member.toString())
    };
  }

  public static fromJSON(json: ClientTeamJSON | undefined): ClientTeam | undefined {
    if (!json) return undefined;

    const leader = new EntityClientRepresentative(
      Guid.fromJSON(json.leader.userId),
      Guid.fromJSON(json.leader.entityId),
      Name.fromJSON(json.leader.name)
    );
    const members = json.members.map((member: string) => Guid.fromJSON(member));
    return new ClientTeam(leader, members);
  }
}
